<template>
  <div class="box">
    <table border="1" cellspacing="0" width="100%">
      <thead>
      <th>栏目名称</th>
      <th>发布时间</th>
      <th>公告数量</th>
      <th>栏目类型</th>
      <th>操作</th>
      </thead>
      <draggable element="tbody" v-model="tableList" @change="onChange">
        <tr v-for="item in tableList" :key="item.id">
          <td>{{ item.name }}</td>
          <td>{{ item.time }}</td>
          <td>{{ item.num }}</td>
          <td>{{ item.type }}</td>
          <td><a>绑定</a></td>
        </tr>
      </draggable>
    </table>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'testTable',
  components: { draggable },
  props: {},
  data() {
    return {
      tableList: [
        { id: 1, name: '活动消息1', time: '2018-08-25 14：54', type: '个人', num: '1000' },
        { id: 2, name: '公司消息2', time: '2018-08-25 14：54', type: '团体', num: '200' },
        { id: 3, name: '个人消息3', time: '2018-08-25 14：54', type: '个人', num: '30000' },
        { id: 4, name: '客户消息4', time: '2018-08-25 14：54', type: '团体', num: '40' }
      ]
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
    onChange(val) {
      console.log('拖拽结束', val)
    }
  },
  watch: {},
  filters: {},
  beforeCreate() {

  },
  created() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  updated() {

  },
  activated() {

  }
}
</script>

<style scoped>

</style>